import { graphql } from '@/gql/generated'

export const CreateShowcaseDocument = graphql(`
  mutation CreateShowcase($showcase: showcases_insert_input!) {
    insert_showcases_one(object: $showcase) {
      id
      created_at
      updated_at
      user_profile_id
      showcase_items(order_by: { created_at: asc }) {
        id
        token_id
        created_at
        updated_at
        token {
          ...GridToken
        }
      }
    }
  }
`)
